import Model from './Model';

export default class Study extends Model {
    study;
    study_id;
    study_name;
    study_level_id;
    study_level;
    institute_name;
    finished;
    start_date;
    end_date;

    toJson() {
        const dtoIds = {
            study_level_id: this.study_level.id,
            study_id: this.study.id,
        };

        return { ...this, ...dtoIds };
    }
}



// WEBPACK FOOTER //
// ./src/models/Study.js